import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class MainGroup_se {
    constructor() {
        this.entity = 'mainGroup';
    }

    delete(id) {
        return Api.delete(this.entity,id)}


    getById(id) {
        if(id && id.length>0) {
            return Api.getById(this.entity, id)
        }else {
            return Api.new_(this.entity)
        }
    }

    getPage(page_,size_) {
        return Api. getPage(this.entity,page_,size_)
    }

    save(model) {
        return Api.save(this.entity,model)
    }

    search(value,page_,size_){
        let search=value;
        let formData=new FormData();
        formData.set("page",page_)
        formData.set("size", size_)
        formData.append("search",search,)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data:formData,
            url: '/private/'+this.entity+'/search',
            headers: {'Content-Type': 'application/json'},
        })
    }



}
export default new MainGroup_se();
